/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalListModelConfigReferencesPathParams = NonNullable<
  operations['internalListModelConfigReferences']['parameters']['path']
>;

export type InternalListModelConfigReferencesQueryParams = NonNullable<
  operations['internalListModelConfigReferences']['parameters']['query']
>;

export interface Input extends InternalListModelConfigReferencesPathParams {
  apiVersion?: string;
  query?: InternalListModelConfigReferencesQueryParams;
}

export async function internalListModelConfigReferences(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/ai-configs/model-configs/{modelConfigKey}/references', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
